'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var ChatInput = require('../ChatInput/ChatInput.js');
var ConversationScrollContainer = require('../ConversationScrollContainer/ConversationScrollContainer.js');
var styledComponents = require('./styled-components.js');

var ConversationAndInput = function (props) {
    var _a = props.messages, messages = _a === void 0 ? [] : _a, getMore = props.getMore, pollForMore = props.pollForMore, handleSend = props.handleSend, pollSpeed = props.pollSpeed;
    return (React__default.createElement(styledComponents.FlexColumnContainer, null,
        React__default.createElement(styledComponents.ExpansionContainer, null,
            React__default.createElement(ConversationScrollContainer, { messages: messages, getMore: getMore, pollForMore: pollForMore, pollSpeed: pollSpeed })),
        React__default.createElement(styledComponents.InputContainer, null,
            React__default.createElement(ChatInput, { onSend: handleSend }))));
};

module.exports = ConversationAndInput;
